module.exports = __webpack_public_path__ + "static/media/chevrot.fc379e48.svg";